import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { css } from "styled-components";

type Props = WidgetProps; 

export interface SavedOrderDetailsContainerStyles {
    wrapper?: InjectableCss;
    container?: GridContainerProps;   
    addressesGridItem?: GridItemProps;
    linesGridItem?: GridItemProps;
    addressAndCartTotalGridItem?: GridItemProps;    
    addressAndCartTotalContainer?: GridContainerProps;
    addressGridItem?: GridItemProps;
    cartTotalGridItem?: GridItemProps;    
}

export const savedOrderDetailsContainerStyles: SavedOrderDetailsContainerStyles ={
    wrapper: {
        css: css`            
            width: 100%;           
        `
    }, 
    addressesGridItem: { width: [12, 12, 7, 8, 8] },
    addressAndCartTotalGridItem: { width: 12 },
    linesGridItem: { 
        width: 12,
            css: css`
                padding: 0 15px;
                ${({ theme }) => {
                    return breakpointMediaQueries(theme, [
                        css`
                            padding: 0 16px;
                        `,
                        css`
                            padding: 0 16px;
                        `,
                    ]);
                }}
        `
    },
    addressGridItem: { 
        width: [12, 12, 7, 8, 8],
        css: css`
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        padding: 0 16px;
                    `,
                    css`
                        padding: 0 16px;
                    `,
                ]);
            }}
        `
    },
    cartTotalGridItem: { 
        width: [12, 12, 5, 4, 4],css: css`
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        padding: 16px 16px 0;
                    `,
                    css`
                        padding: 16px 16px 0;
                    `,
                ]);
            }}
        `
    },

}

const styles = savedOrderDetailsContainerStyles;

const SavedOrderDetailsContainer: React.FC<Props> = ({id}: WidgetProps) => {
    return <StyledWrapper {...styles.wrapper}>
        <GridContainer {...styles.container}>   
            <GridItem {...styles.addressAndCartTotalGridItem}>
                <GridContainer {...styles.addressAndCartTotalContainer}>
                    <GridItem {...styles.addressGridItem}>
                        <Zone zoneName="Content2" contentId={id} />
                    </GridItem>
                    <GridItem {...styles.cartTotalGridItem}>
                        <Zone zoneName="Content3" contentId={id} />
                    </GridItem>
                </GridContainer>
            </GridItem>
            <GridItem {...styles.linesGridItem}>
                <Zone zoneName="Content5" contentId={id} />
            </GridItem>        
        </GridContainer>
    </StyledWrapper>
}

const savedOrderDetailsContainer: WidgetModule = {
    component: SavedOrderDetailsContainer,
    definition: {
        group: "Saved Order Details",
    },
};

export default savedOrderDetailsContainer;